export const itemCss = {
  display: "flex",
  justifyContent: "space-between",
};
